/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useTranslation } from "react-i18next";
import ProductCarousel from "./ProductCarousel";
import ProductTitleVideo from "./ProductTitleVideo";
import ProductShare from "./ProductShare";
import ProductDesc from "./ProductDesc";
import SimilarProductsDynamic from "../common/SimilarProductsDynamic";

function BulasikMakinaDeterjanı() {
const [activeIndex, setActiveIndex] = useState(0);

const handleSelect = (selectedIndex) => {
setActiveIndex(selectedIndex);
};

const handlePrev = () => {
handleSelect(activeIndex === 0 ? 5 : activeIndex - 1);
};

const handleNext = () => {
handleSelect(activeIndex === 5 ? 0 : activeIndex + 1);
};

const { t } = useTranslation();

const [expanded, setExpanded] = useState(false);

const toggleNav = () => {
setExpanded(!expanded);
};

const handleClick = () => {
window.scrollTo(0, 0);
setExpanded(false);
};

const customProducts = [
  {
    "picture": "assets/images/20-kg/5.webp",
    "nav": "/bulasikdeterjaniluks",
    "title": "Bulaşık DeterjanI Lüx"
  },
  {
    "picture": "assets/images/20-kg/7.webp",
    "nav": "/bulasikmakinaparlaticisi",
    "title": "B. Makina Parlatıcısı"
  },
  {
    "picture": "assets/images/20-kg/9.webp",
    "nav": "/bulasikdeterjaniekstra",
    "title": "B. Deterjanı Ekstra"
  },
  {
    "picture": "assets/images/20-kg/13.webp",
    "nav": "/bulasikmakinapro",
    "title": "B. Makina Deterjanı Pro"
  },
  {
    "picture": "assets/images/20-kg/14.webp",
    "nav": "/bulasikmakinaparlaticisipro",
    "title": "B. Makina Parlatıcısı Pro"
  }
]

return (
<>
  <SRLWrapper>
    <section class="product-details section-space">
      <div class="container">
        <div class="row gutter-y-50">
          <div class="col-lg-6 col-xl-6 wow fadeInLeft" data-wow-delay="200ms">
            <div class="product-details__img">
              <div class="swiper product-details__gallery-top p-5">
                <div className="album-list-item">
                  <Link className="ali-link" onClick={handleClick} as={Link} to="/Armur">
                  <div className="ali-img-wrap">
                    <div>
                      <img className="img-fluid blur-up lazyload" src="assets/images/20-kg/6.webp" alt="image" title="image" />
                    </div>
                  </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-6 wow fadeInRight" data-wow-delay="300ms">
            <div class="product-details__content">
              <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                <ProductTitleVideo title="Bulaşık Deterjanı" video="" />
                <span className="product-details__weight"
                  style={{fontSize: '16px', fontWeight: 'bold', color: '#10adad'}}>
                  5 KG - 20 KG
                </span>
              </div>
              {/* Özellikler */}
              <div class="product-details__excerpt mt-4">
                <h5 class="mb-3">ÖZELLİKLERİ</h5>
                <ul class="product-details__list">
                  <li>Dexpur kostik-alkali, kompleks yapıcı madde içeren berrak bir sıvıdır.</li>
                  <li>Farklı sertlikteki sularda yüksek performans sağlar.</li>
                  <li>Dexpur, sadece Dexpur Bulaşık Yıkama Mak. Durulama Maddesi ile birlikte kullanılır.</li>
                </ul>
              </div>

              {/* Kullanım Şekli ve Miktarı */}
              <div class="product-details__excerpt mt-4">
                <h5 class="mb-3">KULLANIM ŞEKLİ VE MİKTARI</h5>
                <ul class="product-details__list">
                  <li>Dexpur, otomatik dozaj cihazı ile makinenin yıkama tankına enjekte edilerek kullanılır.</li>
                  <li>Doz kesinlikle elle ayarlanmamalıdır.</li>
                  <li>0-12 Fransız su sertliğinde 2 gr/lt, 12-24 Fransız su sertliğinde 6-7 gr/lt kullanılır.</li>
                </ul>
              </div>

              <div class="product-details__buttons">
                <Link as={Link} to="/urunlerimiz" class="product-details__btn boskery-btn">
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__text">
                  {" "}
                  DİĞER ÜRÜNLERİMİZ
                </span>
                <i class="icon-arrow-right"></i>
                </Link>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="product-details__description-wrapper">
        <div class="container">
          <div class="product-details__description">
            <h3 class="product-details__description__title">
              Ürün Detayları
            </h3>
            <div class="product-details__text__box wow fadeInUp" data-wow-delay="300ms">

              <h4 class="mt-4 mb-3">ÜRÜN BİLEŞİMİ</h4>
              {/* Ürün Bileşimi Tablosu */}
              <div class="product-details__excerpt mt-4">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead class="table-dark">
                      <tr>
                        <th>MADDE ADI</th>
                        <th>DERİŞİM</th>
                        <th>CAS NO.*</th>
                        <th>EC NO.*</th>
                        <th>TEHLİKE İŞARETİ</th>
                        <th>TEHLİKE İFADELERİ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Deiyonize Su</td>
                        <td>≥ 65 ± 2</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td>1-Hidroksietil-1,1 Difosfonik Asit</td>
                        <td>≥ 8 ± 2</td>
                        <td>2809-21-4</td>
                        <td>220-552-8</td>
                        <td>Xl</td>
                        <td>R 41</td>
                      </tr>
                      <tr>
                        <td>Sodyum Hidroksit</td>
                        <td>≥ 72 ± 2</td>
                        <td>1310-73-2</td>
                        <td>215-185-5</td>
                        <td>C</td>
                        <td>R 35</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Tüketicinin Dikkatine */}
              <div class="alert alert-info mt-4 p-4 text-white" style={{ backgroundColor: "#10adad" }}>
                <h6><strong>TÜKETİCİNİN DİKKATİNE :</strong></h6>
                <ul class="mb-0">
                  <li>Kullanırken eldiven giyiniz. Cildi yanıklara neden olabilir. Uygun eldiven ve göz-yüz koruyucusu kullanınız.</li>
                  <li>Cilt, göz ve giyim eşyası ile temasından kaçınılmalıdır.</li>
                  <li>Cilt ve göz ile temasında derhal bol su ile yıkayınız.</li>
                  <li>Ambalaj tamamen boşaldıktan sonra geri dönüşüm işlemine gönderiniz.</li>
                  <li>Giyim eşyası ile temasında derhal bulaşmış giysileri çıkarın ve cilde temas eden yeri soğuk su ile yıkayınız.</li>
                  <li>Yutulması halinde derhal doktora başvurunuz.</li>
                  <li>Çocukların ulaşamayacağı yerde muhafaza ediniz.</li>
                  <li>Gıda ile temas eden yeri soğuk su ile yıkayınız.</li>
                  <li>Herhangi bir hastalığınız mevcut ise doktora başvurunuz.</li>
                  <li>5°C'nin altında ve 35°C'nin üstündeki sıcaklıklarda ve direkt güneş ışığında bırakmayınız.</li>
                  <li>Başka bir ürün ve madde ile karıştırmayınız. Kapağını kapalı tutunuz.</li>
                  <li>Kullanma talimatını mutlaka okuyunuz.</li>
                  <li>Kapakta bulunan emniyeti pimi kırılmış butonları satın almayınız.</li>
                  <li>Gıda maddelerinden ve çocuklardan uzak tutunuz.</li>
                  <li>Zehirlenme durumunda Ulusal Zehir Danışma Merkezi'nin (UZEM) 114 numaralı telefonunu veya Acil sağlık hizmetlerinin 112 numaralı telefonunu arayınız.</li>
                  <li>Dexpur yanlış kullanım ve saklamadan doğacak zarardan sorumlu değildir.</li>
                </ul>
              </div>

              <div class="danger-warnings mt-4 p-3 bg-danger text-white">
                <h6><strong>⚠️ ZEHİRLENME DURUMUNDA:</strong></h6>
                <div class="alert alert-light mt-3 mb-3 text-dark">
                  <div class="row">
                    <div class="col-md-6">
                      <p class="mb-1"><strong>114'ü</strong></p>
                      <p class="mb-0 small">ULUSAL ZEHİR DANIŞMA MERKEZİ</p>
                    </div>
                    <div class="col-md-6">
                      <p class="mb-1"><strong>112'yi</strong></p>
                      <p class="mb-0 small">ACİL SAĞLIK HİZMETLERİ</p>
                    </div>
                  </div>
                </div>
                
                <div class="alert alert-warning mt-3 mb-0">
                  <p class="mb-0">
                    <strong>⚠️ DİKKAT :</strong> Üretim tarihi, son kullanma tarihi ile parti no ve seri no, ambalajın üzerindedir.
                  </p>
                </div>
              </div>

              <div class="product-info-box mt-4 p-3 bg-light">
                <h6><strong>📋 TEKNİK BİLGİLER:</strong></h6>
                <div class="row">
                    <p><strong>Net Ağırlık:</strong> 5 KG VE 20 KG Seçenekleri mevcuttur.</p>
                    <p><strong>Üretici Firma :</strong> Seymen Kimya Temizlik San. ve Tic. Ltd. Şti.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </SRLWrapper>

    <SimilarProductsDynamic products={customProducts} handleClick={handleClick} />
</>
);
}

export default BulasikMakinaDeterjanı;